import { Component } from "react";
import auth from "../services/authService";

class SaveToken extends Component {
    componentDidMount() {
        const sp = new URLSearchParams(this.props.location.search),
            access_token = sp.get('access_token'),
            refresh_token = sp.get('refresh_token');
        if (access_token){
            auth.storeAccessToken(access_token)
        }
        if (refresh_token) {
            auth.storeRefreshToken(refresh_token)
        }
        window.location = "/";
    }

    render() {
        return null;
    }
}

export default SaveToken;